module.exports = __webpack_public_path__ + "static/media/article_detailed.9ce3ade7.gif";